.title {
  font-size: var(--tuna-typography-fontSize-lg);
  flex-basis: 33.33%;
  flex-shrink: 0;
  flex: 1;
}

.subtitle {
  font-size: var(--tuna-typography-fontSize-lg);
}
